import { withAuthenticationRequired } from '@auth0/auth0-react'

const EventDetail = () => {
  return <div></div>
}

export default withAuthenticationRequired(EventDetail)
